import { IconButton } from '@volvo-cars/react-icons';

import CopyButton from 'atoms/CopyButton';

import styles from './SecretText.module.css';

const HIDDEN = '***********************************';

const SecretText: React.FC<{
  text: string;
  showText: boolean;
  onToggleShow: () => void;
  onRefresh?: () => void;
  isLoading?: boolean;
  preCopy?: () => void;
}> = ({
  text,
  showText,
  onToggleShow,
  onRefresh,
  isLoading = false,
  preCopy,
}) => {
  const textValue = showText ? text : HIDDEN;
  const buttonText = showText ? 'hide' : 'show';

  return (
    <div className={styles.secretDisplay}>
      {isLoading ? (
        <div className="flex w-full justify-center">
          <progress
            aria-label="Loading"
            className="spinner w-16 text-accent-blue"
          />
        </div>
      ) : (
        <div className={styles.textOuterContainer}>
          <div
            className={`${styles.textInnerContainer} ${
              showText ? styles.showText : ''
            }`}
          >
            <p className={styles.tokenText}>{textValue}</p>
          </div>
        </div>
      )}
      <div className={styles.secretTextButtons}>
        <IconButton
          icon={showText ? 'eye-slashed' : 'eye'}
          disabled={isLoading}
          onClick={onToggleShow}
          aria-label={`${buttonText} secret key`}
          variant="clear"
        />
        <CopyButton
          copy={text}
          tooltipPlacement="top"
          disabled={isLoading}
          aria-label="copy secret key"
          preCopy={preCopy}
        />
        {onRefresh && (
          <IconButton
            icon="loop-forward"
            disabled={isLoading}
            onClick={onRefresh}
            aria-label="Regenerate key"
            variant="clear"
          />
        )}
      </div>
    </div>
  );
};

export default SecretText;
